import TeamtreeCar from "./TeamtreeAndCar.js";
export default (function (Vue) {
  Vue.use(TeamtreeCar);
});